import { TranslateIcon } from './TranslateIcon';

/**
 * author: Google
 * id 4486DD26-4110-457E-BBD7-B5D19DF72E4E
 * name translate
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/translate.svg
 * tags
 */
export const LanguageIcon = TranslateIcon;
export default LanguageIcon